import { Box } from '@everlywell/ui-kit';
import ProductPricingButton from 'components/ProductPricingButton';
import StickyFooter from 'components/StickyFooter';
import React from 'react';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { shouldUrlSkipScreenerModal } from 'utils/helpers/urls/skipModal';
import useMdpModals from 'utils/hooks/useMdpModals';

export type StickyMdpCtaProps = {
  label: string;
  url: string;
  hideSeparator?: boolean;
  startingText: string;
  price: {
    value: string;
    frequency: string;
  };
  tracking: {
    ctaText: string;
    sectionHeader: string;
  };
};

function StickyMdpCta(props: StickyMdpCtaProps): JSX.Element {
  const { handleMdpCtaClick } = useMdpModals();
  const { label, url, hideSeparator, startingText, price, tracking } = props;

  const handleCtaClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const skipScreenerModal = shouldUrlSkipScreenerModal({ url });
    handleMdpCtaClick({
      event,
      ctaUrl: url,
      skipScreenerModal,
    });

    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        sectionHeader: tracking.sectionHeader,
        contentfulSection: 'MembershipDetailsPage',
        ctaText: tracking.ctaText,
      },
    });
  };

  return (
    <StickyFooter backgroundColorOverride="tints.white" type="fixed">
      <Box id="sticky-cta-box" width="100%" paddingRight="2" paddingY="4">
        <ProductPricingButton
          id={'sticky-cta-pricing-button'}
          startingText={startingText}
          priceText={price.value}
          size="md"
          billFrequencyText={price.frequency}
          buttonText={label}
          colorScheme="greenCS"
          hideSeparator={hideSeparator}
          onButtonClick={handleCtaClick}
          linkTo={url}
        />
      </Box>
    </StickyFooter>
  );
}

export default React.memo(StickyMdpCta);
